"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divideIntoChunks = exports.chunkArray = void 0;
const MAX_CHUNK_SIZE = 10000;
const DEFAULT_CHUNK_SIZE = 100;
const chunkArray = (array, size) => {
    if (array.length <= size) {
        return [array];
    }
    return [
        array.slice(0, size),
        ...this.chunkArray(array.slice(size), size),
    ];
};
exports.chunkArray = chunkArray;
const divideIntoChunks = (arr, chunkSize) => {
    if (!arr) {
        return [];
    }
    if ((arr === null || arr === void 0 ? void 0 : arr.length) <= chunkSize && chunkSize <= MAX_CHUNK_SIZE) {
        return [arr];
    }
    const chunk = chunkSize && chunkSize > 0
        ? chunkSize <= MAX_CHUNK_SIZE
            ? chunkSize
            : MAX_CHUNK_SIZE
        : DEFAULT_CHUNK_SIZE;
    let chunks = [];
    for (let i = 0; i < arr.length; i += chunk) {
        if (i + chunk > arr.length) {
            chunks.push(arr.slice(i, arr.length));
        }
        else {
            chunks.push(arr.slice(i, i + chunk));
        }
    }
    return chunks;
};
exports.divideIntoChunks = divideIntoChunks;
//# sourceMappingURL=chunkArray.js.map